import createClient from '@economic/http-client';
import { AxiosInstance } from 'axios';
import { INTERNAL_API_APP_TOKEN_URL } from './internalApiClient';

let api: AxiosInstance | null = null;

export function setupAppSettingsGwApiClientEndpoint(host) {
    const appId = '-1';
    const apiVersion = 'v2';
    const namespace = 'e-conomic';
    const settingsServiceEndpoint = `${host}/${apiVersion}/${namespace}/${appId}/`;

    api = createClient(settingsServiceEndpoint, {
        url: INTERNAL_API_APP_TOKEN_URL,
        headerKey: 'Authorization',
        tokenName: 'Bearer ',
        tokenTimeout: 60,
    });
}

export default function getApi() {
    if (!api) {
        throw new Error('Call setupAppSettingsGwApiClientEndpoint before using addons API');
    }

    return api;
}
